import { createStore } from "@tredespace/ui/lib";
import type { BomRow } from "../../engine/bom.ts";

export type BomState = Readonly<{
  rows: readonly BomRow[];
  totalKg: number;
  /** Base-jack extensions in millimetres, one per standard. */
  jackExtensions: readonly number[];
  raisedCount: number;
  /** A diagonal had to be booked as loose Ø48 tube + couplers. */
  anyNonModuleDiagonal: boolean;
}>;

export const bomState = createStore<BomState>({
  rows: [],
  totalKg: 0,
  jackExtensions: [],
  raisedCount: 0,
  anyNonModuleDiagonal: false,
});
